import React, { useState } from "react";
import { Close, Fullscreen } from "@mui/icons-material";
import { styles } from "./styles";

interface Props {
  src?: string;
}

const ImageViewer: React.FC<Props> = ({ src }) => {
  const [modalVisible, setModalVisible] = useState(false);

  return (
    <div style={{ ...styles.imageContainer }}>
      <button style={styles.indicator} onClick={() => setModalVisible(true)}>
        <Fullscreen />
      </button>
      <img style={styles.img} src={src} alt="Imagen" />
      {modalVisible && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "black",
            zIndex: 10000,
          }}
          onClick={() => setModalVisible(false)}
        >
          <button style={styles.indicator}>
            <Close />
          </button>
          <img style={styles.img} src={src} alt="Imagen" />
        </div>
      )}
    </div>
  );
};

export default ImageViewer;
